import { Component, OnInit } from '@angular/core';

import { AuthService } from 'src/app/auth';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit() {
  }

  onClickLogoutButton() {
    this.authService.logout();
  }

}
